<template>
    <div :class="flex_table ? 'flex-table' : ''">
        <list-item
            v-bind:class="no_padding ? 'flex-table--row--no-padding-y' : ''"
            v-for="(item, index) in items"
            v-on:click="action(index)"
            :key="item.id || index"
			:active="can_click && disabled_items.indexOf(item.id) === -1"
		>

            <template slot="title">
                <div :class="h6 ? 'h6' : ''">{{item[title_property]}}</div>
                <h6 class="" v-if="subtitle_property">{{item[subtitle_property]}}</h6>
            </template>

            <template slot="center">
                <label v-if="toggle_property && update_toggle_url" class="toggle" v-bind:class="toggle_property && options ? 'mr-2' : ''">
                    <input type="checkbox" v-bind:checked="item[toggle_property]" v-on:click="toggle(index)">
                    <span class="toggle--slider"></span>
                </label>
                <div v-if="disabled_items.indexOf(item.id) === -1" class="flex-table--header-content-offset">
                    <div v-if="options" class="btn-group">
                        <svg-image
                            :src="'/svg/' + resource_group +'/more.svg'"
                            width="20px"
                            height="25px"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        ></svg-image>
                        <div class="dropdown-menu dropdown-menu-right">
                            <svg-image
								v-for="(option, option_index) in options"
								:key="option_index"
                                :src="option.icon_src"
                                width="20px"
                                height="20px"
                                :highlight="option.icon_color"
                                class="dropdown-item"
                                :auto_hover="true"
                                :spaced="true"
                                @click="resolveOption(mergeItemWithOption(item, option_index))"
                            >
                                <span class="text-danger">{{option.label}}</span>
                            </svg-image>
                        </div>
                    </div>
                </div>
                <div v-else-if="admin_items.indexOf(item.id) !== -1" >
                   <small class="text-primary"> Created by Under Construction </small>
                </div>
            </template>

        </list-item>
		<div v-if="!items.length" class="flex-table--row">
			<div class="flex-table--cell flex-table--cell-grow-always">
				<h6 class="">{{no_results_message}}</h6>
			</div>
		</div>
    </div>
</template>

<style scoped>
.h6 {
    font-size: 14px;
    font-weight: normal;
    font-family: "Sen", "sans-serif";
    color: #7e7e7e;
}
</style>

<script>
    import ListItem from "./ListItem";
    export default {
        name: "ListComponent",
        components: {ListItem},
        props: {
            items: {
                type: Array,
				default: () => { return []; }
            },

			//Disabled items expects the item to have an id.
			//This would then a list of disabled id's
			disabled_items: {
            	type: Array,
				default: () => { return []; }
			},

            admin_items: {
            	type: Array,
				default: () => { return []; }
			},

            title_property: {
                type: String,
                default: 'name'
            },
            subtitle_property: {
                type: String,
                default: null
            },

            //default url open clicked on (if null only the emit will trigger)
            action_url: {
                type: String,
            },
            //default prop that contains the url open
            action_url_prop: {
                type: String,
            },

            no_results_message: {
                type: String,
                default: "No results found"
            },

            //active for form.active is a good example
            toggle_property: {
                type: String,
                default: null
            },
            //url to update form.active
            //this will use patch method
            update_toggle_url: {
                type: String,
                default: null
            },

            toggle_method: {
                type: String,
                default: 'patch'
            },

            no_padding: {
                type: Boolean,
                default: false
            },

            flex_table: {
                type: Boolean,
                default: true
            },

            h6: {
                type: Boolean,
                default: false
            },

			can_click: {
            	type: Boolean,
				default: true
			},

            //dropdown options [{icon_src='/svg/bin.svg', action_url='/forms/?/delete', label='remove'}, etc...]
            //if null hide options menu
            //Option action will be performed on a GET request
            options: {
                type: Array,
                default: null,
                validator: value => {
                    //Expecting [icon_src, icon_color, icon_highlight, action_url, action_method, action_resolve, label, emitting_tag, confirm_message, confirm_message_prop]
                    if (!value.length) return false;
                    for (let i = 0; i < value.length; i ++){
                        if (!value[i].icon_src) return false;
                        if (!value[i].label) return false;
                        if (!value[i].action_url) return false; //if action method is emit, will emit with action_url
                        if (value[i].action_method && ['post', 'get', 'delete', 'update', 'patch', 'emit'].indexOf(value[i].action_method) === -1) return false;
                        if (value[i].action_resolve && ['href', 'reload', 'emit_optionClicked'].indexOf(value[i].action_resolve) === -1) return false;
                    }
                    return true;
                }
            }
        },

        data() {
            return {
                currentPath: '',

            }
        },

        beforeMount() {
            this.currentPath = window.location.pathname.split('/').slice(-2).join('/');
        },

        methods: {
            action(index){
                this.$emit('action', index);
                if (this.action_url) window.location.href = this.action_url.replace('?', this.items[index].id);
                else if (this.currentPath === 'forms/' || this.currentPath === 'timeline/forms') window.open(this.items[index][this.action_url_prop], '_self');
                else if (this.action_url_prop) window.open(this.items[index][this.action_url_prop], '_blank');
            },

            toggle(index){
                this.items[index][this.toggle_property] = !this.items[index][this.toggle_property];
                axios[this.toggle_method](this.update_toggle_url.replace('?', this.items[index].id), {
                    active: this.items[index][this.toggle_property]
                });
            },
            mergeItemWithOption(item, option_index){
                const option = Object.assign({}, this.options[option_index])
                option.item = item;

                return option;
            },
            resolveOption(compiled_option){
                if (compiled_option.confirm_message && !confirm(this.compileMessage(compiled_option))){
                    return;
                }

                if (compiled_option.action_method === 'emit'){
                	this.$emit(compiled_option.action_url, compiled_option);
                	return;
				}

                axios[compiled_option.action_method || 'get'](compiled_option.action_url.replace('?', compiled_option.item.id))
                    .then(response => {
                        if (compiled_option.action_resolve === 'href')
                            window.location.href = compiled_option.action_url.replace('?', compiled_option.item.id)
                        else if (compiled_option.action_resolve === 'reload')
                            window.location.reload();
                        else if (compiled_option.action_resolve === 'emit_optionClicked')
                            this.$emit('optionClicked', compiled_option);
                    });
            },

            compileMessage(compiled_option){
                const prop = compiled_option.item[compiled_option.confirm_message_prop || 'name'];
                return compiled_option.confirm_message.replace('%', (prop || ''));
            }
        }
    }
</script>
